import Field from "skin/entry/cmp/field";
import def from "./def";

export default function TypedField({ type, ...rest }) {
	const o = def[type];
	return <Field {...o} {...rest} />
}